import './filtros-cabecera.css';
import { LocationPicker } from './LocationPicker';
import { PeriodPicker } from './PeriodPicker';

/**
 * Arriba a la derecha, junto a Ayuda, solo dos desplegables pequeños: «Local ▾»
 * (si hay más de un local) y «Este mes ▾» (Alex, 12 oct 2026). Igual en
 * celular: ya no hace falta plegarlos en «Filtros».
 */
export function ScopePicker({ soloLocal = false }: { soloLocal?: boolean }): JSX.Element {
  return (
    <div className="scope-picker">
      <LocationPicker />
      {!soloLocal && <PeriodPicker />}
    </div>
  );
}
